import { ReactNode, useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from '../../i18n/index';
import { LoadingState } from './LoadingState';

interface I18nProviderProps {
  children: ReactNode;
}

export function I18nProvider({ children }: I18nProviderProps) {
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    const initializeI18n = async () => {
      try {
        setIsLoading(true);
        
        // Wait for i18n to be initialized
        if (!i18n.isInitialized) {
          await new Promise((resolve) => {
            i18n.on('initialized', resolve);
          });
        }
        
        // The language detector plugin will handle initial language setting
        console.log('i18n initialized with language:', i18n.language);
      } catch (error) {
        console.error('Error initializing i18n:', error);
      } finally {
        setIsLoading(false);
      }
    };
    
    initializeI18n();
  }, []);
  
  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <LoadingState spinnerSize="xl" className="py-0" />
      </div>
    );
  }
  
  return (
    <I18nextProvider i18n={i18n}>
      {children}
    </I18nextProvider>
  );
}